import { Modal, Box, Text, Button, Group } from '@mantine/core';
import { PinInput } from '@mantine/core';

const ModalMailVerification = ({
  isOpen,
  onClose,
  mail,
  timer,
  verificationCode,
  setVerificationCode,
  onVerify,
  onResend,
  verificationError,
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title="Verificación de correo electrónico"
      centered
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      styles={{
        title: {
          fontSize: '18px',
          fontWeight: '600',
        },
        close: {
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#FFEBF2',
          },
        },
      }}
    >
      <Box p={'5px 10px'}>
        <Text size="sm" weight={500} mb={'xs'} c={'dimmed'}>
          Se envió un codigo al mail que ingreso:
        </Text>
        <Box mb={'md'} bg={'#FFEBF2'} p={'8px 12px'} style={{ borderRadius: '8px' }}>
          <Text size="md" c={'#8B2252'} fw={600} >
            {mail ? mail : '00-00000000'}
          </Text>
        </Box>

        {timer > 0 && (
          <Text size="sm" c="#D42F70" mb={'sm'} fs={'italic'}>
            Puedes reenviar el código en <b>{timer}</b> segundos
          </Text>
        )}

        <Box mb={'3rem'}>
          <PinInput
            length={6}
            size="md"
            value={verificationCode}
            onChange={setVerificationCode}
            onComplete={onVerify}
            error={verificationError}
          />
          {verificationError && (
            <Text size="sm" c="red" style={{ marginBottom: '16px' }}>
              Código incorrecto. Por favor, inténtalo de nuevo.
            </Text>
          )}
        </Box>
        <Group position="center" spacing="md">
          <Button
            variant="light" color="gray"
            onClick={onClose}
          >
            Cancelar
          </Button>
          {/*<Button
            color="rgb(242, 10, 95)"
            disabled={verificationCode.length < 6 || timer > 0}
            onClick={onVerify}
          >
            Verificar
          </Button>*/}
        </Group>

        {timer === 0 && (
          <Text
            size="xs"
            style={{
              marginTop: '16px',
              color: '#8B2252',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={onResend}
          >
            ¿No recibiste el código? Reenviar
          </Text>
        )}
      </Box>
    </Modal>
  );
};

export default ModalMailVerification;